export default __webpack_public_path__ + "static/media/zine-artwork5.9e953156.jpg";